import organisations from './organisations'
import districts from './districts'
import data from './data'
import people from './people.json'
import petition from './petition'
import questions from './questions'
import message_examples from './message-examples'
import people_email_templates from './people_email_templates'
import locale from './locale'

if (locale === undefined) throw new Error('locale is undefined')
if (organisations === undefined) throw new Error('organisations is undefined')
if (districts === undefined) throw new Error('districts is undefined')
if (data === undefined) throw new Error('data is undefined')
if (people === undefined) throw new Error('people is undefined')
if (people_email_templates === undefined) throw new Error('people_email_templates is undefined')
if (petition === undefined) throw new Error('petition is undefined')
if (questions === undefined) throw new Error('questions is undefined')
if (message_examples === undefined) throw new Error('message_examples is undefined')

export default {
  data,
  petition,
  questions,
  organisations,
  districts,
  people,
  people_email_templates,
  message_examples,
  locale,
}
